import * as moment from 'moment';
import * as R from 'ramda';

import { Locale } from 'ha/i18n/types';
import { ISODate } from './types';

// ISODate
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// formatDate :: String -> String -> ISODate|undefined -> String
const formatDate = (
  locale: Locale = Locale.en,
  format: string,
  isoDate: ISODate,
) =>
  moment(isoDate)
    .locale(locale)
    .format(format);

export default R.curryN(2, formatDate);
